<template>
  <v-card>
    <v-toolbar dark color="#06377a">
      <v-toolbar-title>
        Detail Material
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="mr-1" icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar
      no-shadow
      flat
      color="#f8f9fa"
      class="pb-5"
      style="height: 120px; border-bottom: 1px solid #e8eaed"
    >
      <div class="mt-10" style="width: 100%; padding-top: 10px">
        <v-row>
          <v-col>
            <v-text-field
              label="Price Information"
              v-model="price_item"
              prefix="IDR"
              outlined
              small
              flat
              style="font-weight: bold"
              maxlength="16"
              :rules="[(v) => !!v || '*Price information is required']"
              @keypress="filter(event)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
              class="px-5 py-6 mt-1"
              color="success"
              dark
              large
              depressed
              :loading="loading"
              @click="updatePrice()"
            >
              Update Price
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-toolbar>
    <v-card-text class="pt-5">
      <v-row>
        <v-col cols="12" md="6">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td width="200">Request No.</td>
                  <td class="bold">{{ data.request_no }}</td>
                </tr>
                <tr>
                  <td>Requester.</td>
                  <td class="bold">{{ data.request_by }}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td class="bold">
                    <status :status="data.status"></status>
                  </td>
                </tr>
                <tr>
                  <td>Material No.</td>
                  <td class="bold">
                    {{ data.material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Old Material No.</td>
                  <td class="bold">
                    {{ data.old_material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Item Name</td>
                  <td class="bold">{{ data.inc_name || "-" }}</td>
                </tr>
                <tr>
                  <td>INC Code</td>
                  <td class="bold">{{ data.inc_code || "-" }}</td>
                </tr>
                <tr>
                  <td>Item Description</td>
                  <td class="bold">
                    <div style="word-break:break-all">
                      {{ data.description }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Basic Data Text</td>
                  <td class="bold">
                    <div style="word-break:break-all">
                      {{ data.basic_data_text || "-" }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Colloquial Name</td>
                  <td class="bold">{{ data.colloquial_name || "-" }}</td>
                </tr>
                <tr>
                  <td>Manufacturer</td>
                  <td class="bold">
                    {{ data.manufacturer }} - {{ data.manufacturer_name }}
                  </td>
                </tr>
                <tr>
                  <td>Part Number</td>
                  <td class="bold">
                    {{ data.part_number }}
                    <span v-if="!data.part_number">-</span>
                  </td>
                </tr>
                <tr>
                  <td>Automatic PO</td>
                  <td class="bold">
                    <v-icon v-if="data.automatic_po === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Source List</td>
                  <td class="bold">
                    <v-icon v-if="data.source_list === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Group</td>
                  <td class="bold">
                    {{ data.purchasing_group }} -
                    {{ data.purchasing_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Value Key</td>
                  <td class="bold">
                    {{ data.purchasing_value_key }} -
                    {{ data.purchasing_value_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Group</td>
                  <td class="bold">
                    {{ data.mrp_group }} - {{ data.mrp_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Type</td>
                  <td class="bold">
                    {{ data.mrp_type }} - {{ data.mrp_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Control</td>
                  <td class="bold">
                    {{ data.mrp_control }} - {{ data.mrp_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Profile</td>
                  <td class="bold">
                    {{ data.mrp_profile }} - {{ data.mrp_profile_name }}
                  </td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td class="bold">
                    {{ data.remarks }}
                    <span v-if="!data.remarks">-</span>
                  </td>
                </tr>

                <tr>
                  <td width="200">Request Date</td>
                  <td class="bold">{{ data.request_date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="6">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td width="200">Plant</td>
                  <td class="bold">{{ data.plant }} - {{ data.plant_name }}</td>
                </tr>
                <tr>
                  <td>Industry Sector</td>
                  <td class="bold">
                    {{ data.industry_sector }} - {{ data.industry_sector_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Type</td>
                  <td class="bold">
                    {{ data.material_type }} -
                    {{ data.material_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Base Unit</td>
                  <td class="bold">
                    {{ data.base_unit }} - {{ data.base_unit_name }}
                  </td>
                </tr>
                <tr>
                  <td>Order Unit</td>
                  <td class="bold">
                    {{ data.order_unit !== "null" ? data.order_unit : "" }} -
                    {{
                      data.order_unit_name !== "null"
                        ? data.order_unit_name
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Division</td>
                  <td class="bold">
                    {{ data.division }} - {{ data.divisi_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Group</td>
                  <td class="bold">
                    {{ data.material_group }} - {{ data.material_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>External Group</td>
                  <td class="bold">
                    {{ data.external_group }} - {{ data.external_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Lab/Office</td>
                  <td class="bold">
                    {{ data.lab_office }} - {{ data.lab_office_name }}
                  </td>
                </tr>
                <tr>
                  <td>Basic Material</td>
                  <td class="bold">
                    {{ data.basic_material }} - {{ data.basic_material }}
                  </td>
                </tr>
                <tr>
                  <td>Lot Size Procedure</td>
                  <td class="bold">
                    {{ data.lot_size_procedure }} -
                    {{ data.lot_size_procedure_name }}
                  </td>
                </tr>
                <tr>
                  <td>Procurement Type</td>
                  <td class="bold">
                    {{ data.proc_type }} - {{ data.proc_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Special Proc.</td>
                  <td class="bold">
                    {{ data.special_proc }} - {{ data.special_proc_name }}
                  </td>
                </tr>
                <tr>
                  <td>Planned Delivery Time</td>
                  <td class="bold">{{ data.planned_delivery_time }} Days</td>
                </tr>
                <tr>
                  <td>Availibility Check</td>
                  <td class="bold">
                    {{ data.availibility_check }} -
                    {{ data.availibility_check_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Category</td>
                  <td class="bold">
                    {{ data.valuation_category }} -
                    {{ data.valuation_category_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Type</td>
                  <td class="bold">
                    {{ data.valuation_type || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Class</td>
                  <td class="bold">
                    {{ data.valuation_class }} - {{ data.valuation_class_name }}
                  </td>
                </tr>
                <tr>
                  <td>Price Control</td>
                  <td class="bold">
                    {{ data.price_control }} - {{ data.price_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>Request Type</td>
                  <td class="bold">
                    {{ data.type_input === "NEW" ? "New" : "Extend" }}
                  </td>
                </tr>
                <tr>
                  <td>Storage Location</td>
                  <td class="bold">
                    {{ data.storage_location }} -
                    {{ data.storage_location_name }}
                  </td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td class="bold">
                    <div v-if="data.price_item" style="font-weight: bold;">
                      IDR
                      {{
                        data.price_item
                          ? data.price_item
                              .toLocaleString()
                              .replace(/[,]/g, ".")
                          : "0"
                      }}
                    </div>
                    <div v-else>
                      <v-btn
                        depressed
                        x-small
                        style="color: #FF7043"
                        color="#FBE9E7"
                      >
                        Need Price Information
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>

    <v-snackbar
      v-model="snackbar.open"
      :timeout="snackbar.timeout ? snackbar.timeout : 7000"
      top
    >
      {{ snackbar.message_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.button_type ? snackbar.button_type : 'primary'"
          v-bind="attrs"
          @click="snackbar.open = false"
        >
          {{ snackbar.button_text ? snackbar.button_text : "Close" }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import StatusVue from "../component/Status.vue"

export default {
  components: {
    status: StatusVue,
  },
  data() {
    return {
      name: "DetailMaterial",
      title: "Detail Material",
      data: null,
      price_item: null,
      storage_user_id: atob(localStorage.getItem("user_id")),
      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },
    }
  },
  watch: {
    price_item(val) {
      val = val.replace(/[.]/g, "")
      var c = val ? parseInt(val).toLocaleString() : "0"
      this.price_item = c.replace(/[,]/g, ".")
    },
  },
  mounted() {
    this.getMaterial()
  },
  methods: {
    getMaterial() {
      const self = this
      const id = this.$attrs.data.id
      const url = this.base_url + "material/getdata/detail/" + id

      this.axios.get(url).then(function(response) {
        self.data = response.data
        self.price_item = response.data.price_item
          ? response.data.price_item.toLocaleString().replace(/[,]/g, ".")
          : 0
      })
    },

    filter: function(evt) {
      evt = evt ? evt : window.event
      let expect = evt.target.value.toString() + evt.key.toString()

      if (!/^[-+]?[0-9]*\.?[0-9]*\.?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    closeDialog() {
      this.$emit("closeDialog")
    },

    updatePrice() {
      if (!this.price_item) {
        this.snackbar = {
          open: true,
          message_text: "Field price information cannot be empty.",
          button_type: "error",
        }
        return false
      }

      this.$dialog.confirm({
        text: `Are you sure, you want to update price this item ?`,
        title: `Update Price Item`,
        overlay: true,
        actions: {
          false: "No",
          true: {
            color: "primary",
            text: "Yes",
            handle: () => {
              var self = this
              var url = self.base_url + "material/process/add_procurement"
              var data = {
                id: self.data.id,
                price_item: self.price_item.toString(),
                user_id: self.storage_user_id,
              }

              this.axios
                .post(url, data)
                .then(function(response) {
                  if (response.status === 200) {
                    self.finishProcess()
                  }
                })
                .catch(() => {
                  self.snackbar = {
                    open: true,
                    message_text: `Failed process material, please check again your item`,
                    button_type: "error",
                  }
                })
            },
          },
        },
      })
    },
    finishProcess() {
      this.$emit("finishProcess")
    },
  },
}
</script>

<style>
.bold {
  font-weight: 600 !important;
}
</style>
